<template>
  <v-off-canvas id="client-tour-quote-offcanvas" offcanvas-class="offcanvas-end" @closed="$emit('closed')">
    <resizable-container>
      <off-canvas-header>
        <div class="d-flex align-items-center">
          <v-icon class="text-primary" icon="info" size="xxl" space="me-8" />

          <h5 id="client-details-offcanvas-label" class="offcanvas-title">
            {{ $t("tourClient.quote") }}
          </h5>
        </div>
      </off-canvas-header>

      <off-canvas-body>
        <div class="d-flex flex-column justify-content-between h-100">
          <div>
            <v-checkbox
              id="case-quote-optional"
              v-model="optional"
              :label="$t('clientTour.quoteOptionalText')"
              :left="true"
              :right="false"
              class="mb-16"
              for-key="case-quote-optional"
            />

            <div>
              <p class="mb-8">{{ $t("clientTour.quotePriceText") }}</p>

              <v-form-input-radio
                v-model="priceType"
                :formValueOptions="[
                  { key: 'tp', label: $t('clientTour.quoteTotalPrice') },
                  { key: 'ppp', label: $t('clientTour.quotePricePerPerson') },
                ]"
                form-class="mb-8"
              />
            </div>
          </div>

          <v-button
            :disabled="disableBtn"
            :is-loading="disableBtn"
            class="btn-submit-form btn-icon w-fit align-self-end"
            size="sm"
            variant="primary"
            @click="openQuote"
          >
            {{ $t("general.button.see") }}
            <v-icon icon="arrow-right" size="sm" space="ms-12" />
          </v-button>
        </div>
      </off-canvas-body>
    </resizable-container>
  </v-off-canvas>
</template>

<script lang="ts" setup>
import { defineProps, PropType, ref } from "vue";
import { VCheckbox, VFormInputRadio } from "@uniqoders/form";
import VOffCanvas from "@/components/vendor/basic/offcanvas/VOffCanvas.vue";
import OffCanvasHeader from "@/components/vendor/basic/offcanvas/OffCanvasHeader.vue";
import OffCanvasBody from "@/components/vendor/basic/offcanvas/OffCanvasBody.vue";
import VButton from "@/components/vendor/basic/button/VButton.vue";
import VIcon from "@/components/vendor/basic/icon/VIcon.vue";
import ResizableContainer from "@/components/resizablecontainer/ResizableContainer.vue";
import { useRouter } from "vue-router";

const props = defineProps({
  quoteRoute: {
    type: Object as PropType<any>,
    required: true,
  },
  openedWindow: {
    type: [String, Number, Boolean, Object, Array] as PropType<any>,
    required: false,
  },
});

const emit = defineEmits<{
  (e: "closed"): void;
  (e: "setOpenedWindow", value: any): void;
}>();

const disableBtn = ref(false);
const optional = ref(true);
const priceType = ref("ppp");

const router = useRouter();

const openQuote = () => {
  emit("closed");
  const query = {
    ...props.quoteRoute.value.query,
    is_optional: optional.value ? 1 : 0,
  };

  if (priceType.value === "ppp") {
    query.price_type = "ppp";
  }

  if (props.openedWindow && !props.openedWindow.closed) {
    props.openedWindow.close();
  }

  const routeData = router.resolve({ name: props.quoteRoute.value.url, query });

  const width = 1000;
  const height = 800;
  const topWindow = window.top ?? window;
  const top = topWindow.outerHeight / 2 + topWindow.screenY - height / 2;
  const left = topWindow.outerWidth / 2 + topWindow.screenX - width / 2;

  const openedWindowLocal = window.open(
    routeData.href,
    "_blank",
    `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=${left},width=${width},height=${height},top=${top}`
  );

  emit("setOpenedWindow", openedWindowLocal);
};
</script>
